(() => {
  const elementName = "celu-cart-dispatch";
  const locationStorageKey = "celu_cart_dispatch_location_v2";
  const emptyLocation = { type: "none", label: "" };

  if (customElements.get(elementName)) return;

  let lookupPromise = null;

  const metroAreas = [
    // Opcional: apenas para o teu teste em Portugal
    { country: "PT", label: "Lisbon", lat: 38.7223, lon: -9.1393, radius: 30 },

    // UK
    { country: "GB", label: "London", lat: 51.5072, lon: -0.1276, radius: 42 },
    { country: "GB", label: "Birmingham", lat: 52.4862, lon: -1.8904, radius: 35 },
    { country: "GB", label: "Manchester", lat: 53.4808, lon: -2.2426, radius: 35 },
    { country: "GB", label: "Liverpool", lat: 53.4084, lon: -2.9916, radius: 30 },
    { country: "GB", label: "Leeds", lat: 53.8008, lon: -1.5491, radius: 30 },
    { country: "GB", label: "Glasgow", lat: 55.8642, lon: -4.2518, radius: 35 },
    { country: "GB", label: "Edinburgh", lat: 55.9533, lon: -3.1883, radius: 30 },
    { country: "GB", label: "Bristol", lat: 51.4545, lon: -2.5879, radius: 30 },
    { country: "GB", label: "Cardiff", lat: 51.4816, lon: -3.1791, radius: 30 },
    { country: "GB", label: "Newcastle", lat: 54.9783, lon: -1.6178, radius: 30 },
    { country: "GB", label: "Sheffield", lat: 53.3811, lon: -1.4701, radius: 25 },
    { country: "GB", label: "Nottingham", lat: 52.9548, lon: -1.1581, radius: 25 },
    { country: "GB", label: "Leicester", lat: 52.6369, lon: -1.1398, radius: 25 },
    { country: "GB", label: "Southampton", lat: 50.9097, lon: -1.4044, radius: 30 },
    { country: "GB", label: "Belfast", lat: 54.5973, lon: -5.9301, radius: 30 },

    // USA
    { country: "US", label: "New York", lat: 40.7128, lon: -74.0060, radius: 55 },
    { country: "US", label: "Los Angeles", lat: 34.0522, lon: -118.2437, radius: 60 },
    { country: "US", label: "Chicago", lat: 41.8781, lon: -87.6298, radius: 50 },
    { country: "US", label: "Dallas", lat: 32.7767, lon: -96.7970, radius: 45 },
    { country: "US", label: "Fort Worth", lat: 32.7555, lon: -97.3308, radius: 35 },
    { country: "US", label: "Houston", lat: 29.7604, lon: -95.3698, radius: 55 },
    { country: "US", label: "Miami", lat: 25.7617, lon: -80.1918, radius: 50 },
    { country: "US", label: "Atlanta", lat: 33.7490, lon: -84.3880, radius: 50 },
    { country: "US", label: "Philadelphia", lat: 39.9526, lon: -75.1652, radius: 45 },
    { country: "US", label: "Washington DC", lat: 38.9072, lon: -77.0369, radius: 45 },
    { country: "US", label: "Boston", lat: 42.3601, lon: -71.0589, radius: 40 },
    { country: "US", label: "San Francisco", lat: 37.7749, lon: -122.4194, radius: 45 },
    { country: "US", label: "San Jose", lat: 37.3382, lon: -121.8863, radius: 35 },
    { country: "US", label: "Seattle", lat: 47.6062, lon: -122.3321, radius: 45 },
    { country: "US", label: "Phoenix", lat: 33.4484, lon: -112.0740, radius: 40 },
    { country: "US", label: "Denver", lat: 39.7392, lon: -104.9903, radius: 40 },
    { country: "US", label: "San Diego", lat: 32.7157, lon: -117.1611, radius: 40 },
    { country: "US", label: "Austin", lat: 30.2672, lon: -97.7431, radius: 35 },
    { country: "US", label: "Tampa", lat: 27.9506, lon: -82.4572, radius: 40 },
    { country: "US", label: "Orlando", lat: 28.5383, lon: -81.3792, radius: 35 },
    { country: "US", label: "Charlotte", lat: 35.2271, lon: -80.8431, radius: 35 },
    { country: "US", label: "Minneapolis", lat: 44.9778, lon: -93.2650, radius: 35 },
    { country: "US", label: "Saint Paul", lat: 44.9537, lon: -93.0900, radius: 28 },
    { country: "US", label: "Detroit", lat: 42.3314, lon: -83.0458, radius: 40 },
    { country: "US", label: "Nashville", lat: 36.1627, lon: -86.7816, radius: 35 },
    { country: "US", label: "Las Vegas", lat: 36.1699, lon: -115.1398, radius: 35 },
    { country: "US", label: "Portland", lat: 45.5152, lon: -122.6784, radius: 40 },
    { country: "US", label: "Baltimore", lat: 39.2904, lon: -76.6122, radius: 35 },
    { country: "US", label: "Raleigh", lat: 35.7796, lon: -78.6382, radius: 30 },
    { country: "US", label: "Durham", lat: 35.9940, lon: -78.8986, radius: 25 },
    { country: "US", label: "San Antonio", lat: 29.4241, lon: -98.4936, radius: 35 },
    { country: "US", label: "Columbus", lat: 39.9612, lon: -82.9988, radius: 30 },
    { country: "US", label: "Indianapolis", lat: 39.7684, lon: -86.1581, radius: 30 },
    { country: "US", label: "Cleveland", lat: 41.4993, lon: -81.6944, radius: 30 },
    { country: "US", label: "Pittsburgh", lat: 40.4406, lon: -79.9959, radius: 30 },
    { country: "US", label: "Cincinnati", lat: 39.1031, lon: -84.5120, radius: 30 },
    { country: "US", label: "Kansas City", lat: 39.0997, lon: -94.5786, radius: 30 },
    { country: "US", label: "Milwaukee", lat: 43.0389, lon: -87.9065, radius: 28 },
    { country: "US", label: "Jacksonville", lat: 30.3322, lon: -81.6557, radius: 30 },
    { country: "US", label: "New Orleans", lat: 29.9511, lon: -90.0715, radius: 30 },
    { country: "US", label: "Oklahoma City", lat: 35.4676, lon: -97.5164, radius: 30 },
    { country: "US", label: "Memphis", lat: 35.1495, lon: -90.0490, radius: 30 },
    { country: "US", label: "Richmond", lat: 37.5407, lon: -77.4360, radius: 28 },
    { country: "US", label: "Virginia Beach", lat: 36.8529, lon: -75.9780, radius: 28 },
    { country: "US", label: "St. Louis", lat: 38.6270, lon: -90.1994, radius: 35 },
    { country: "US", label: "Sacramento", lat: 38.5816, lon: -121.4944, radius: 35 },
    { country: "US", label: "Salt Lake", lat: 40.7608, lon: -111.8910, radius: 35 },
    { country: "US", label: "Louisville", lat: 38.2527, lon: -85.7585, radius: 30 }
  ];

  function cleanText(value) {
    const text = String(value || "").replace(/\s+/g, " ").trim();
    return text.length > 0 && text.length <= 80 ? text : "";
  }

  function normaliseCountry(value) {
    const country = cleanText(value).toUpperCase();
    return country === "UK" ? "GB" : country;
  }

  function numberOrNull(value) {
    const number = Number(value);
    return Number.isFinite(number) ? number : null;
  }

  function distanceKm(lat1, lon1, lat2, lon2) {
    const radians = (value) => (value * Math.PI) / 180;
    const earthRadiusKm = 6371;
    const dLat = radians(lat2 - lat1);
    const dLon = radians(lon2 - lon1);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(radians(lat1)) *
        Math.cos(radians(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);

    return earthRadiusKm * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function nearbyMetro(country, latitude, longitude) {
    if (latitude === null || longitude === null) return "";

    let match = null;

    for (const metro of metroAreas) {
      if (metro.country !== country) continue;

      const distance = distanceKm(
        latitude,
        longitude,
        metro.lat,
        metro.lon
      );

      if (distance <= metro.radius && (!match || distance < match.distance)) {
        match = { label: metro.label, distance };
      }
    }

    return match ? match.label : "";
  }

  function locationFromResponse(data) {
    const country = normaliseCountry(data.country_code);
    const latitude = numberOrNull(data.latitude);
    const longitude = numberOrNull(data.longitude);

    const metro = nearbyMetro(country, latitude, longitude);

    if (metro) {
      return { type: "city", label: metro };
    }

    const region = cleanText(data.region);

    if (region && (country === "US" || country === "GB")) {
      return { type: "region", label: region };
    }

    return emptyLocation;
  }

  function readStoredLocation() {
    try {
      const raw = window.sessionStorage.getItem(locationStorageKey);

      if (raw === null) {
        return { found: false, location: emptyLocation };
      }

      const stored = JSON.parse(raw);
      const label = cleanText(stored?.label);
      const type =
        stored?.type === "city" || stored?.type === "region"
          ? stored.type
          : "none";

      return {
        found: true,
        location: label && type !== "none" ? { type, label } : emptyLocation
      };
    } catch {
      return { found: false, location: emptyLocation };
    }
  }

  function storeLocation(location) {
    const safeLocation =
      location?.label && (location.type === "city" || location.type === "region")
        ? { type: location.type, label: cleanText(location.label) }
        : emptyLocation;

    try {
      window.sessionStorage.setItem(
        locationStorageKey,
        JSON.stringify(safeLocation)
      );
    } catch {
      // Sem sessionStorage, lookupPromise evita repetições nesta página.
    }

    return safeLocation;
  }

  async function resolveLocation() {
    const stored = readStoredLocation();

    if (stored.found) {
      return stored.location;
    }

    if (lookupPromise) {
      return lookupPromise;
    }

    lookupPromise = (async () => {
      const controller =
        typeof AbortController === "function" ? new AbortController() : null;

      const timeoutId = controller
        ? window.setTimeout(() => controller.abort(), 3500)
        : null;

      try {
        const response = await fetch(
          "https://ipwho.is/?fields=success,country_code,region,latitude,longitude",
          {
            method: "GET",
            credentials: "omit",
            headers: { Accept: "application/json" },
            signal: controller ? controller.signal : undefined
          }
        );

        if (!response.ok) {
          return storeLocation(emptyLocation);
        }

        const data = await response.json();

        if (!data?.success) {
          return storeLocation(emptyLocation);
        }

        return storeLocation(locationFromResponse(data));
      } catch {
        return storeLocation(emptyLocation);
      } finally {
        if (timeoutId !== null) {
          window.clearTimeout(timeoutId);
        }
      }
    })();

    return lookupPromise;
  }

  class CeluCartDispatch extends HTMLElement {
    connectedCallback() {
      const stored = readStoredLocation();

      if (stored.found) {
        this.renderLocation(stored.location);
        return;
      }

      const drawer = this.closest("cart-drawer");

      if (!drawer || drawer.classList.contains("active")) {
        this.queueLookup();
        return;
      }

      this.drawerObserver = new MutationObserver(() => {
        if (!drawer.classList.contains("active")) return;

        this.drawerObserver?.disconnect();
        this.drawerObserver = null;
        this.queueLookup();
      });

      this.drawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ["class"]
      });
    }

    disconnectedCallback() {
      this.drawerObserver?.disconnect();
      this.drawerObserver = null;

      if (this.idleHandle !== undefined) {
        if (
          this.idleType === "idle" &&
          typeof window.cancelIdleCallback === "function"
        ) {
          window.cancelIdleCallback(this.idleHandle);
        } else {
          window.clearTimeout(this.idleHandle);
        }

        this.idleHandle = undefined;
        this.lookupQueued = false;
      }
    }

    queueLookup() {
      if (this.lookupQueued) return;

      this.lookupQueued = true;

      const run = () => {
        this.idleHandle = undefined;
        this.lookupQueued = false;

        resolveLocation().then((location) => {
          if (this.isConnected) {
            this.renderLocation(location);
          }
        });
      };

      if (typeof window.requestIdleCallback === "function") {
        this.idleType = "idle";
        this.idleHandle = window.requestIdleCallback(run, {
          timeout: 1500
        });
      } else {
        this.idleType = "timeout";
        this.idleHandle = window.setTimeout(run, 0);
      }
    }

    renderLocation(location) {
      const locationElement = this.querySelector("[data-celu-cart-city]");

      if (!locationElement) return;

      if (location?.label) {
        locationElement.textContent = ` To ${location.label}`;
        locationElement.hidden = false;
      } else {
        locationElement.textContent = "";
        locationElement.hidden = true;
      }
    }
  }

  customElements.define(elementName, CeluCartDispatch);
})();